// Registro central dos testes A/B ativos.
// Formato: NOME_DESCRITIVO: "nome_exato_no_firebase_remote_config"
//
// Ao criar um novo teste:
// 1. Adicione o parametro aqui
// 2. Adicione o default no firebase-remote-config.js
// 3. Crie o parametro no Firebase Console com os valores 0 e 1

window.FIREBASE_AB_TESTS = {
  SLIDESHOW_BANNER: "abtesting",
  MULTICOLUN: "multicolunmABTest",
};

(function preloadActiveTests() {
  if (!window.ARZZ_AB_TESTS || typeof window.ARZZ_AB_TESTS.getVariant !== "function") {
    window.setTimeout(preloadActiveTests, 50);
    return;
  }

  Object.values(window.FIREBASE_AB_TESTS).forEach(function (parameterName) {
    window.ARZZ_AB_TESTS.getVariant(parameterName);
  });
})();
